import { Reducer } from 'redux';
import { ConsentsState, ConsentsActionTypes } from './types';
import { StudentActionTypes } from '../types';
import { CoreActionTypes } from '../core/types';

const initialState: ConsentsState = {
  isSectionStarted: false,
  isSectionComplete: false,
};

const reducer: Reducer<ConsentsState> = (state = initialState, action): ConsentsState => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...initialState,
        ...action.payload.student.consents,
      };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.DELETE_DOCUMENT_FILE_SUCCESS:
    case StudentActionTypes.DELETE_FINANCE_FILE_SUCCESS:
    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS:
    case StudentActionTypes.UPDATE_OFFER_EVIDENCE_SUCCESS:
    case CoreActionTypes.UPDATE_ASSIGNED_AGENTS_SUCCESS:
      if (action.payload.consents) {
        return {
          ...initialState,
          ...action.payload.consents,
        };
      }
      return state;
    case ConsentsActionTypes.UPDATE_CONSENTS_FIELD:
      return {
        ...state,
        [action.payload.fieldName]: action.payload.value,
      };
    default:
      return state;
  }
};

export { reducer as consentsReducer };
